<template>
    <v-card class="ma-0 pa-3 wrapper">
        <v-container class="pa-0 d-flex align-center justify-space-between">
            <div class="d-flex align-center gap-2">
                <v-chip
                    label
                    class="product-label"
                >
                    <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M1.78892 3.26322C1.85169 3.07455 1.98682 2.91854 2.16458 2.82946C2.34235 2.74039 2.54821 2.72556 2.73692 2.78822L3.00192 2.87722L3.04192 2.89022C3.66792 3.09922 4.19692 3.27522 4.61392 3.46922C5.05592 3.67522 5.43992 3.92922 5.73092 4.33422C6.02192 4.73722 6.14292 5.18222 6.19792 5.66722C6.24992 6.12322 6.24992 6.68122 6.24992 7.34122V10.0002C6.24992 11.4352 6.25192 12.4372 6.35292 13.1922C6.45192 13.9262 6.63292 14.3142 6.90892 14.5912C7.18592 14.8682 7.57492 15.0482 8.30892 15.1472C9.06392 15.2482 10.0649 15.2502 11.4999 15.2502H18.4999C18.6988 15.2502 18.8896 15.3292 19.0302 15.4699C19.1709 15.6105 19.2499 15.8013 19.2499 16.0002C19.2499 16.1991 19.1709 16.3899 19.0302 16.5305C18.8896 16.6712 18.6988 16.7502 18.4999 16.7502H11.4449C10.0779 16.7502 8.97492 16.7502 8.10792 16.6342C7.20792 16.5122 6.44992 16.2542 5.84792 15.6522C5.24592 15.0502 4.98792 14.2922 4.86692 13.3922C4.74992 12.5252 4.74992 11.4222 4.74992 10.0552V7.38322C4.74992 6.67022 4.74992 6.19822 4.70792 5.83722C4.66792 5.49522 4.60092 5.33122 4.51392 5.21122C4.42792 5.09122 4.29292 4.97422 3.98092 4.82922C3.65092 4.67622 3.20392 4.52522 2.52792 4.29922L2.26292 4.21222C2.16936 4.18105 2.08287 4.13173 2.0084 4.06709C1.93392 4.00245 1.87292 3.92376 1.8289 3.83552C1.78487 3.74728 1.75868 3.65122 1.75182 3.55285C1.74496 3.45448 1.75756 3.35671 1.78892 3.26322Z" fill="black"/>
                    <path opacity="0.5" d="M6.24219 6.5C6.24619 6.76 6.24785 7.04033 6.24719 7.341V10C6.24719 11.435 6.24919 12.437 6.35019 13.192C6.36552 13.302 6.38219 13.4047 6.40019 13.5H16.5202C17.4792 13.5 17.9582 13.5 18.3342 13.252C18.7102 13.004 18.8992 12.564 19.2762 11.682L19.7062 10.682C20.5152 8.792 20.9192 7.848 20.4752 7.174C20.0312 6.5 19.0032 6.5 16.9472 6.5H6.24219Z" fill="black"/>
                    <path d="M7.75 9.5C7.75 9.30109 7.82902 9.11032 7.96967 8.96967C8.11032 8.82902 8.30109 8.75 8.5 8.75H11.5C11.6989 8.75 11.8897 8.82902 12.0303 8.96967C12.171 9.11032 12.25 9.30109 12.25 9.5C12.25 9.69891 12.171 9.88968 12.0303 10.0303C11.8897 10.171 11.6989 10.25 11.5 10.25H8.5C8.30109 10.25 8.11032 10.171 7.96967 10.0303C7.82902 9.88968 7.75 9.69891 7.75 9.5ZM8 18.5C8.39782 18.5 8.77936 18.658 9.06066 18.9393C9.34196 19.2206 9.5 19.6022 9.5 20C9.5 20.3978 9.34196 20.7794 9.06066 21.0607C8.77936 21.342 8.39782 21.5 8 21.5C7.60218 21.5 7.22064 21.342 6.93934 21.0607C6.65804 20.7794 6.5 20.3978 6.5 20C6.5 19.6022 6.65804 19.2206 6.93934 18.9393C7.22064 18.658 7.60218 18.5 8 18.5ZM18.5 20C18.5 19.6022 18.342 19.2206 18.0607 18.9393C17.7794 18.658 17.3978 18.5 17 18.5C16.6022 18.5 16.2206 18.658 15.9393 18.9393C15.658 19.2206 15.5 19.6022 15.5 20C15.5 20.3978 15.658 20.7794 15.9393 21.0607C16.2206 21.342 16.6022 21.5 17 21.5C17.3978 21.5 17.7794 21.342 18.0607 21.0607C18.342 20.7794 18.5 20.3978 18.5 20Z" fill="black"/>
                    </svg>
                </v-chip>
                <v-card-text class="pa-0 text-body-2">{{ $t('out-of-stock') }}</v-card-text>
            </div>
        </v-container>
        <v-card-text class="pa-0 text-caption white--text mt-4 mb-6" style="width: 150px;">
          {{ $t('products which their inventory is less than the order point.') }}
        </v-card-text>
        <div
          v-if="$store.getters.getpermission && $store.getters.getpermission.includes('overview')"
        >
          <v-container
            v-if="outOfStockProduct != null && outOfStockProduct != undefined"
            class="pa-0 d-flex align-center gap-2"
          >
              <v-card-text
                class="pa-0 text-body-1"
              >
              {{ outOfStockProduct }}
              </v-card-text>
              <v-card-text class="pa-0 text-caption white--text">{{ $t('product') }}</v-card-text>
          </v-container>
          <v-container
            v-if="outOfStockProduct == null && outOfStockProduct == undefined"
            class="pa-0"
          >
            <v-card-text class="pa-0 text-caption">
              {{ $t('there is no enough information for showing.') }}
            </v-card-text>
          </v-container>
        </div>
        <div v-else>
          <v-card-text class="pa-0 text-caption">
            {{ $t("you don't have access to this information") }}
          </v-card-text>
        </div>
    </v-card>
</template>

<script>
export default {
  data () {
    return {
      dashboardType: 'home',
      outOfStockProduct: null
    }
  },
  methods: {
    fetchList () {
      var app = this
      app.$axios.get(this.$endpoint + 'productsreport', {
        params: {
          report: 'overview',
          dateType: 'year',
          threshold: 0.1
        }
      })
        .then(r => {
          this.outOfStockProduct = r.data.orderPointCount
        })
        .catch(e => {
          console.error('Error:', e)
        })
        .finally(() => {
          this.loading = false
        })
    }
  },
  mounted () {
    this.fetchList()
  }
}
</script>

<style scoped>
.wrapper {
    background-color: #161616;
    padding: 10px;
    color: #fff;
}
.product-label {
    padding: 0 !important;
    width: 35px;
    height: 33px;
    background: #fff !important;
    display: flex;
    align-items: center;
    justify-content: center;
}
.v-card__text {
    width: auto;
}
.v-sheet.v-card:not(.v-sheet--outlined) {
    box-shadow: none !important;
}
</style>
